<template>
  <j-modal
    title="司机标签"
    :width="800"
    :visible="visible"
    :okButtonProps="{ class:{'jee-hidden': true} }"
    @cancel="handleCancel">

    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        :customHeaderRow="customHeaderRow"
        :customRow="customRow"
        @change="handleTableChange">

        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{record.updateByName}}</span>
          <img :title="record.updateByName"  v-else :src="getImgView(text)" height="25px" alt=""  style="width:25px;font-size: 12px;font-style: italic;border-radius:50%"/>
        </template>


        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
        </span>

      </a-table>
    </div>

    <a-button class="add_label" @click="addLabel">添加标签</a-button>
    <dm-driver-label-modal ref="modalForm" @ok="modalFormOk"></dm-driver-label-modal>
  </j-modal>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DmDriverLabelModal from './modal/DmDriverLabelModal__Style#Drawer'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'DmDriverLabelList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DmDriverLabelModal
    },
    data () {
      return {
        description: '司机标签列表',
        // 表头
        columns: [
          {
            title:'标签',
            align:"center",
            dataIndex: 'driverLabel_dictText'
          },
          {
            title:'操作人',
            align:"center",
            dataIndex: 'updateByAvatar',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title:'操作时间',
            align:"center",
            dataIndex: 'updateTime'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/dm/dmDriverLabel/list",
          delete: "/dm/dmDriverLabel/delete"
          
        },
        visible:false,
        disableMixinCreated:true
      }
    },
    created() {

    },
    computed: {

    },
    methods: {
      show(driverId){
        this.visible = true
        this.queryParam.driverId = driverId;
        this.queryParam.pageSize = 1000;
        this.loadData(1);
      },handleCancel(){
        this.visible = false;
        this.$emit("ok");
      },addLabel(){
        this.$refs.modalForm.add({
          driverId:this.queryParam.driverId
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  @import '~@assets/less/dm/tableList.less';
  @import '~@assets/less/dm/newTable.less';
  /deep/ .ant-modal-footer{
    display: none;
  }
  .add_label{
    width:100%;
    margin-top: 20px;
    background-color: rgba(230, 237, 245, 1)!important;
    color: #0a1629;
    font-size: 16px;
  }
</style>